import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import { Apiurl, parseData,GetLocalStorageParsed } from '../utils/page'

import axios from 'axios'
import VendorProductsDetailComponent from '../../Components/VendorProductsDetail/VendorProductsDetailComponent';
import Loader from '../../Components/Loader/Loader'

const VendorProductDetail = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
    const [loading, setLoading] = useState("");
  
  const [loginToken, setLoginToken] = useState(FetchToken || null);

  const [TopVendorsData, setTopVendorsData] = useState([]);
    
   
 
  
  
    // Get Vendors
    // const GetTopVendors = () => {
    //   const option = {
    //     method: "GET",
    //     headers: {
    //       accept: '*/*',
    //       'Authorization': `Bearer ${loginToken ? loginToken : null}`
    //     },
    //     url: `${Apiurl()}/api/Customer/TopVendors`,
    //   };
    //   axios(option)
    //     .then((e) => {
    //       setTopVendorsData(parseData(e.data.result));
    //     })
    //     .catch((error) => {
    //     });
    // };
  
    // useEffect(() => {
    //   GetTopVendors();
    // }, []);  
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
 {loading === "vendor"  ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
        <Header setLoginToken={setLoginToken} setLoading ={setLoading }/>
        <VendorProductsDetailComponent TopVendorsData={TopVendorsData} setLoading={setLoading}/>
        <Footer/>
      
    </div>
  )
}

export default VendorProductDetail
